<template>
  <div>
    <naj-box :title="local.governmentAttorney.title">
      <v-row>
        <v-col
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.selectbox"
            :label="local.governmentAttorney.governmentAttorneyName"
            :value.sync="formModel.organizationId"
            :value-name.sync="formModel.organizationName"
            :items="governmentAgencies"
            item-text="organizationName"
            item-value="id"
            item-description="unifiedNumber"
            validates="required|isIdAllowed"
            :disabled="isViewMode||isRelatedCasePartyToLiquidatorOrJudicialGuard"
            @change="onOrganizationChange"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <naj-address
      :title="local.titleHeader.addressGovernmental"
      :form-model="formModel.placeAddress"
      :required="required"
      :is-view-mode="isViewMode"
    ></naj-address>
    <span v-if="isRepresentative">
      <representatives-form
        :form-model="formModel"
        :required="required"
      ></representatives-form>
    </span>
  </div>
</template>

<script>
import { partyTypeEnum } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
import RepresentativesForm from './forms/representatives-form.vue';
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  inject: ['$validator'],
  components: { RepresentativesForm },
  props: ['formModel', 'required', 'isViewMode', 'isRepresentative'],
  computed: {
    ...mapLUTState(['governmentAgencies']),
    isRelatedCasePartyToLiquidatorOrJudicialGuard() {
      const mainCasePartyObjectKey = this.formModel.casePartyObjectKey;
      return this.formModel.relatedPartiesInfo.some(
        party =>
          party.casePartyObjectKey === mainCasePartyObjectKey &&
          (party.relatedPartyType === partyTypeEnum.judicialGuard || party.relatedPartyType === partyTypeEnum.liquidator)
      );
    },
  },
  watch: {
    governmentAgencies(val) {
      if (val && val.length > 0 && this.isRelatedCasePartyToLiquidatorOrJudicialGuard) {
        this.setMatchingOrganization();
      }
    },
  },
  created() {
    this.getGovernmentAgencies()
      .then(() => {
        if (this.governmentAgencies && this.governmentAgencies.length > 0 && this.isRelatedCasePartyToLiquidatorOrJudicialGuard) {
          this.setMatchingOrganization();
        }
      });
  },
  methods: {
    ...mapLUTActions(['getGovernmentAgencies']),
    setMatchingOrganization() {
      const matchingOrganization = this.governmentAgencies.find(org => org.unifiedNumber === '7020579301'); // مركز الإسناد والتصفية السعودي
      if (matchingOrganization) {
        this.$set(this.formModel, 'organizationId', matchingOrganization.id);
        this.$set(this.formModel, 'organizationName', matchingOrganization.organizationName);
        this.$set(this.formModel, 'unifiedNumber', '7020579301');
      }
    },
    onOrganizationChange(organizationId) {
      const governmentAgency = this.governmentAgencies.find(e => e.id === organizationId);
      this.$set(this.formModel, 'unifiedNumber', governmentAgency ? governmentAgency.unifiedNumber : undefined);
      this.$set(this.formModel, 'name', governmentAgency ? governmentAgency.organizationName : undefined);
    },
  },
};
</script>
